






import { Vue } from "../../constants/constants";
import {
  KEYS,
  getRemoteConfigAsString,
  ensureRemoteConfigInitialize,
} from "../../firebase";

import dynamicSection from "./dynamic-section.vue";

export default Vue.component("dynamic-sections", {
  components: {
    dynamicSection,
  },
  data() {
    return {
      sections: [],
    };
  },

  mounted() {
    this.getSectionsData();
  },

  methods: {
    getSectionsData() {
      ensureRemoteConfigInitialize().then(() => {
        let sectionsData = JSON.parse(
          getRemoteConfigAsString(KEYS.DYNAMIC_SECTIONS)
        );
        const sectionsOrder = getRemoteConfigAsString(
          KEYS.DELIVERY_SECTIONS_ORDER
        ).split(",");
        let sections = [];
        if (
          sectionsOrder.length &&
          sectionsData["dynamic_sections"] &&
          sectionsData["dynamic_sections"].length
        ) {
          let sectionsMaxNumber = sectionsData["dynamic_sections"].length;
          const availableSections: [] = sectionsData["dynamic_sections"];
          sectionsOrder.forEach((sectionName) => {
            const section = availableSections.find(
              (item) => item.section_name === sectionName.trim()
            );
            if (section && sectionsMaxNumber != 0) {
              sections.push(section);
              sectionsMaxNumber--;
            }
          });
        }
        this.sections = sections;
      });
    },
  },
});
